<div class="xr-page xr-profile">
  <header class="xr-page-header">
    <div>
      <h1 class="xr-page-title">{{ "profile.title" | translate }}</h1>
    </div>
  </header>
  <app-account></app-account>
</div>
